import { Component, Output, EventEmitter, Inject } from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "time-picker",
  templateUrl: "./time-picker.component.html",
  styleUrls: ["./time-picker.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: TimePickerComponent,
      multi: true,
    },
  ],
})
export class TimePickerComponent implements ControlValueAccessor {
  @Output() close = new EventEmitter<void>();
  @Output() timeSelected = new EventEmitter<{
    hour: string;
    minute: string;
    ampm: string;
  }>();

  auto = true;
  hhmm = "hh"; 
  ampm = "PM";
  dial = [];
  hour = ""; 
  minute = "00"; 

  private date = new Date();
  private onChange = (v: Date) => {};
  private onTouched = () => {};

  constructor( @Inject(MAT_DIALOG_DATA) public data: any,
  private dialogRef: MatDialogRef<TimePickerComponent>) {
    const j = 84;
    for (let min = 1; min <= 12; min++) {
      const hh = String(min);
      const mm = String("00" + ((min * 5) % 60)).slice(-2);
      const x = 1 + Math.sin(Math.PI * 2 * (min / 12));
      const y = 1 - Math.cos(Math.PI * 2 * (min / 12));
      this.dial.push({ top: `${j * y}px`, left: `${j * x}px`, hh, mm });
    }
  }

  writeValue(v: Date) {
    this.date = v || new Date();
    const hh = this.date.getHours();
    const mm = this.date.getMinutes();
    this.ampm = hh < 12 ? "AM" : "PM";
    this.hour = ""; 
    this.minute = "00"; 
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  timeChange($event: string) {
    if (this.hhmm === "hh") {
      this.hour = $event;
      if (this.auto) {
        this.hhmm = "mm"; 
      }
    } else {
      this.minute = $event;
    }
  }

  rotateHand() {
    const deg = this.hhmm === "hh" ? +this.hour * 5 : +this.minute;
    return `rotate(${deg * 6}deg)`;
  }

  isTimeSelected(): boolean {
    return this.hour !== "" && this.minute !== "";
  }

  cancel(): void {
    this.dialogRef.close();  
  }

  ok() {
    let hh = +this.hour + (this.ampm === "PM" ? 12 : 0);
    if ((this.ampm === "AM" && hh === 12) || hh === 24) {
      hh -= 12;
    }
    this.date.setHours(hh);
    this.date.setMinutes(+this.minute);

    this.timeSelected.emit({
      hour: this.hour,
      minute: this.minute,
      ampm: this.ampm,
    });

    this.close.emit();
  }
}
